import axios from 'axios'

let instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
})

export function useApiClient() {
  return instance
}
